import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { rootUrl } from '../../helpers'
import { FaBoxOpen, FaTrash } from 'react-icons/fa'
import { useAuth } from '../../context/auth-context'
import ConfirmationDialog from '../../components/ConfirmationDialog'

export default function Opening() {
  const [open, setOpen] = useState([])
  const [bank, setBank] = useState([])
  const [mod, setMod] = useState({ open: false, title: '', message: '', onConfirm: null })
  const [modalOpen, setModalOpen] = useState(false)
  const auth = useAuth()

  const handleModClose = () => {
    setMod({ ...mod, open: false })
  }

  const fetchData = async () => {
    try {
      const data = await axios.get(rootUrl(`/getOpen/${auth.user.id}`))
      setOpen(data.data.open)
      setBank(data.data.bank)
    } catch (e) {
      toast.error(e?.message)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleSubmit = async (data) => {
    data['cid'] = auth.user.cid
    data['year'] = new Date().getFullYear()
    data['uid'] = auth.user.id.toString()

    const resp = await axios.post(rootUrl(`/postOpen`), data)

    if (resp.data.status == 200) {
      toast.success("Successful")
      fetchData()
    } else {
      toast.error("Something went wrong")
    }
  }

  const delOpening = async (bid) => {
    setMod({
      open: true,
      title: 'Warning',
      message: 'Are you sure you want to delete this item?',
      onConfirm: async () => {
        try {
          await axios.get(rootUrl(`/delOpening/${bid}`))
          handleModClose()
          fetchData()
        } catch (e) {
          toast.error(e?.message)
        }
      }
    })
  }

  return (
    <div className='p-4 bg-white rounded-lg shadow-lg'>
      <ConfirmationDialog
        open={mod.open}
        title={mod.title}
        message={mod.message}
        onConfirm={mod.onConfirm}
        onCancel={handleModClose}
      />

      <div className='flex justify-between'>
        <h2 className='flex items-center font-semibold text-2xl'>
          <FaBoxOpen className="mr-2" /> Opening Cash Balances
        </h2>

        <button
          onClick={() => setModalOpen(true)}
          className="px-4 py-2 bg-blue-950 text-white rounded m-1"
        >
          Add opening cash balance
        </button>
      </div>

      <hr />

      <AddItemModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleSubmit}
        bank={bank}
      />

      <table className="w-full border-collapse border border-gray-300 mt-5">
        <thead>
          <tr className="bg-blue-950 text-white">
            <th className="border p-2 text-left">Sno</th>
            <th className="border p-2 text-left">Bank</th>
            <th className="border p-2 text-right">Amount</th>
            <th className="border p-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {open.map((item, index) => (
            <tr key={item.id || index} className="text-center">
              <td className="border p-2 text-left">{index + 1}</td>
              <td className="border p-2 text-left">
                {bank.find((a) => a.id == item.fkey)?.name || item.fkey}
              </td>
              <td className="border p-2 text-right">{item.amount}</td>
              <td className="border p-2 text-left">
                <FaTrash
                  className='text-red-500 cursor-pointer'
                  onClick={() => delOpening(item.fkey)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const AddItemModal = ({ isOpen, onClose, onSubmit, bank }) => {
  const [formData, setFormData] = useState({
    amount: "",
    fkey: "",
  })

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const isEmpty = Object.values(formData).some((value) => !value)
    if (isEmpty) {
      toast.error("Ensure all fields are filled")
      return
    }
    onSubmit(formData)
    onClose()
    setFormData({ amount: "", fkey: "" })
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl font-semibold mb-4">Add Opening Cash Balance</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="block text-sm font-medium">Amount</label>
            <input
              type="number"
              step="0.01"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              placeholder="Enter amount"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block text-sm font-medium">Bank</label>
            <select
              name="fkey"
              value={formData.fkey}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              required
            >
              <option value="">Select bank</option>
              {bank.map((fkey) => (
                <option key={fkey.id} value={fkey.id}>
                  {fkey.name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-end space-x-2">
            <button
              type="button"
              className="px-4 py-2 bg-gray-300 rounded"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
